module.exports = __webpack_public_path__ + "static/media/renegades_logo.0fbffb6f.png";